import { Component, inject } from '@angular/core';

import { PwaUpdateService } from '../../services/pwa-update/pwa-update.service';

@Component({
  selector: 'mt-pwa-update-blocker',
  standalone: true,
  template: `
    @if (pwaUpdateService.updateAvailable()) {
      <div class="update-overlay">
        <div class="update-card">
          <h1>Nova atualização disponível</h1>
          <p>
            Uma nova versão da aplicação foi publicada.
            A atualização é obrigatória e a página será recarregada.
          </p>

          <button type="button" [disabled]="pwaUpdateService.isUpdating()" (click)="updateNow()">
            {{ pwaUpdateService.isUpdating() ? 'Atualizando...' : 'Atualizar agora' }}
          </button>
        </div>
      </div>
    }
  `,
  styles: [
    `
      .update-overlay {
        position: fixed;
        inset: 0;
        z-index: 99999;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px;
        background: rgba(15, 23, 42, 0.96);
      }

      .update-card {
        width: 100%;
        max-width: 480px;
        padding: 32px;
        border-radius: 16px;
        background: #fff;
        text-align: center;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
      }

      .update-card h1 {
        margin: 0 0 16px;
        font-size: 24px;
      }

      .update-card p {
        margin: 0 0 24px;
        color: #4b5563;
        line-height: 1.5;
      }

      .update-card button {
        min-width: 180px;
        height: 44px;
        border: 0;
        border-radius: 10px;
        background: #1677ff;
        color: #fff;
        font-weight: 600;
        cursor: pointer;
      }

      .update-card button:disabled {
        opacity: 0.7;
        cursor: not-allowed;
      }
    `
  ]
})
export class PwaUpdateBlockerComponent {
  readonly pwaUpdateService = inject(PwaUpdateService);

  updateNow(): void {
    void this.pwaUpdateService.applyMandatoryUpdate();
  }
}